import { Resource, ResourceReviewItem } from '../../../types';

export interface BlockingResourceReviews {
  unsubmitted: ResourceReviewItem[];
  processing: ResourceReviewItem[];
  failed: ResourceReviewItem[];
}

export function getBlockingResourceReviewsForShot(
  shotId: string,
  resources: Resource[],
  reviews: ResourceReviewItem[],
): BlockingResourceReviews {
  const currentResourceURLs = new Set(resources.map(resource => resource.url));
  const currentReviews = reviews.filter(review =>
    review.shotId === shotId && currentResourceURLs.has(review.resourceUrl)
  );

  return {
    unsubmitted: currentReviews.filter(review => review.status === 'unsubmitted'),
    processing: currentReviews.filter(review => review.status === 'processing'),
    failed: currentReviews.filter(review => review.status === 'failed'),
  };
}

// 解说音色参考音频（preset_audio）非 active 时即阻断生成——包括 failed（未通过审核），
// 因为对该音色只能到「音色预设管理」重提，不能在分镜里替换。区别于普通素材 failed 不阻断的口径。
export function hasBlockingPresetAudio(blocking: BlockingResourceReviews): boolean {
  return [blocking.unsubmitted, blocking.processing, blocking.failed].some(list =>
    list.some(review => review.presetAudio === true)
  );
}
